import Deal from './Deal.context';
export default Deal;
